module.exports = __webpack_public_path__ + "img/AtaMuhammad-Bekas.9dd4c651.jpg";